import gql from 'graphql-tag';

export default gql`
  mutation createOneMessageMutation(
    $text: String!
    $type: String!
    $data: MessageDataInputTC
    $repliedMessage: MongoID
    $course: MongoID
    $isMetaMessage: Boolean
  ) {
    createOneMessageMutation(
      text: $text
      type: $type
      data: $data
      repliedMessage: $repliedMessage
      course: $course
      isMetaMessage: $isMetaMessage
    ) {
      record {
        _id
        text
        createdAt
        dialog
        messageUsers {
          user
          isRead
        }
        creator {
          login
          _id
          firstName
          lastName
          isSubscribedToPosts
          email
          phone
          avatar {
            path
          }
          role
        }
      }
    }
  }
`;
